import React, { useContext } from "react"
import * as styles from "./styles.module.scss"
import Link from "gatsby-link"
import cx from "classnames"
import useScrollDirection, { Direction } from "../../hooks/use-scroll-direction"
// import { NavContext } from "components/Document"

const navigation = [
  { label: "ALL", slug: "all" },
  { label: "HOMEBUYING", slug: "homebuying" },
  { label: "REFINANCING", slug: "refinancing" },
  { label: "AFFORDABLE LENDING", slug: "AFFORDABLE lending" },
  { label: "FIRST-TIME HOMEBUYERS", slug: "FIRST-TIME homebuyers" },
  { label: "TOOLS", slug: "tools" },
]

const SubNavbarResources: React.FC = () => {
  const scrolled = true
  // const { scrolled } = useContext(NavContext)
  const scrollDirection = useScrollDirection({
    initialDirection: Direction.Up,
  })
  return (
    <div
      className={cx({
        [styles.subNavbar]: true,
        [styles.isScrolled]: scrolled,
        [styles.isRolledUp]: scrollDirection === Direction.Down,
      })}
    >
      <div className={styles.padding}>
        <div className={styles.links}>
          <ul className={styles.linksList}>
            {navigation.map((item) => (
              <li className={styles.linkWrap} key={item.slug}>
                <Link
                  className={styles.link}
                  activeClassName={styles.active}
                  to={`/${item.slug}`}
                  id="LinkTo-resources"
                >
                  <span className={styles.underline}>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default SubNavbarResources
